module.exports = __webpack_public_path__ + "img/76308.105d55cf.svg";